import localFont from 'next/font/local';

/**
 * The two Part 1 faces, loaded through `next/font/local` rather than a
 * `@font-face` in `marketing.module.css`.
 *
 * Preloads are disabled so these faces load when CSS needs them instead of
 * competing with initial resources through font preload requests. `next/font`
 * still generates metric-matched fallbacks (`size-adjust`, `ascent-override`)
 * from the font files to reduce layout shift while `swap` shows the fallback.
 *
 * `adjustFontFallback` names the family those metrics are derived against – a
 * serif for the display face, Arial for the body – which is what makes the
 * generated fallback close rather than merely scaled.
 */
export const financierDisplay = localFont({
  src: '../../../public/fonts/financier-display-light.woff2',
  weight: '300',
  style: 'normal',
  display: 'swap',
  variable: '--font-financier-display',
  adjustFontFallback: 'Times New Roman',
  preload: false,
});

/**
 * Applied wherever `marketing.module.css`'s `.tokens` class goes, because the
 * two font tokens on it read these variables. `MarketingSurface` and
 * `SiteHeader` both carry it.
 */
export const halcyDmSans = localFont({
  src: '../../../public/fonts/dm-sans-variable.woff2',
  weight: '100 1000',
  style: 'normal',
  display: 'swap',
  variable: '--font-halcy-dm-sans',
  adjustFontFallback: 'Arial',
  preload: false,
});

/** The two font variables, for the class list of anything carrying `.tokens`. */
export const marketingFontVariables = `${financierDisplay.variable} ${halcyDmSans.variable}`;
